import React from 'react';
import { motion } from 'framer-motion';
export function FeaturedMasterclasses() {
  const customEase = [0.16, 1, 0.3, 1];
  const classes = [{
    city: 'Brisbane',
    title: 'The Signature Masterclass',
    description: 'Our foundational course designed for everyday women wanting to master their own face. Learn skin prep, flawless base application, and a versatile day-to-night eye.',
    image: 'https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?w=800&q=80',
    span: 'col-span-1 md:col-span-2',
    price: '$495 per person',
    date: 'Next class: March 2026',
    details: '4 hours · Max 12 students · All skill levels · Products provided',
    urgency: 'Limited spots available'
  }, {
    city: 'Sydney',
    title: 'The Signature Masterclass',
    description: 'Join us in our Sydney studio for an intimate, hands-on session focusing on modern, glowing makeup techniques tailored to your unique features.',
    image: 'https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=800&q=80',
    span: 'col-span-1',
    price: '$495 per person',
    date: 'Next class: April 2026',
    details: '4 hours · Max 12 students · All skill levels · Products provided'
  }, {
    city: 'Melbourne',
    title: 'The Signature Masterclass',
    description: 'Elevate your beauty routine in our Melbourne masterclass. Discover industry secrets for long-lasting wear and effortless elegance.',
    image: 'https://images.unsplash.com/photo-1522337660859-02fbefca4702?w=800&q=80',
    span: 'col-span-1',
    price: '$495 per person',
    date: 'Next class: April 2026',
    details: '4 hours · Max 12 students · All skill levels · Products provided'
  }];
  return <section id="masterclasses" className="py-24 md:py-32 bg-parchment texture-grain" data-id="element-105">
      <div className="max-w-[90rem] mx-auto px-6 lg:px-12" data-id="element-106">
        {/* Section Intro */}
        <div className="mb-20" data-id="element-107">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          ease: customEase
        }} className="font-serif text-5xl md:text-7xl font-light text-ink mb-8" data-id="element-108">
            Upcoming Masterclasses
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: customEase
        }} className="font-sans text-stone text-lg leading-relaxed max-w-xl" data-id="element-109">
            Whether you're a complete beginner or a beauty enthusiast looking to
            refine your skills, our in-person masterclasses are designed to
            build your confidence and technique.
          </motion.p>
        </div>

        {/* Editorial Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-16" data-id="element-110">
          {classes.map((cls, index) => <motion.div key={cls.city} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: index * 0.2,
          ease: customEase
        }} className={`group cursor-pointer ${cls.span} flex flex-col`} data-id="element-111">
              <div className="relative overflow-hidden aspect-[4/3] mb-6 bg-cream-dark" data-id="element-112">
                <img src={cls.image} alt={`${cls.city} Masterclass`} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105 img-editorial" data-id="element-113" />
                <div className="warm-overlay absolute inset-0" data-id="element-114"></div>
                <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-4 py-2 text-xs uppercase tracking-widest text-ink" data-id="element-115">
                  {cls.city}
                </div>
              </div>

              <div className="flex flex-col flex-grow" data-id="element-116">
                <div className="flex justify-between items-baseline mb-2 gap-4" data-id="element-117">
                  <h3 className="font-serif text-3xl text-ink group-hover:text-copper transition-colors" data-id="element-118">
                    {cls.title}
                  </h3>
                  <span className="font-sans text-ink font-medium whitespace-nowrap" data-id="element-119">
                    {cls.price}
                  </span>
                </div>

                <div className="flex items-center gap-3 mb-4" data-id="element-120">
                  <span className="text-sm font-medium text-copper" data-id="element-121">
                    {cls.date}
                  </span>
                  {cls.urgency && <>
                      <span className="w-1 h-1 rounded-full bg-copper/50" data-id="element-122"></span>
                      <span className="text-xs uppercase tracking-wider text-copper font-semibold" data-id="element-123">
                        {cls.urgency}
                      </span>
                    </>}
                </div>

                <p className="text-stone font-sans mb-4 line-clamp-2" data-id="element-124">
                  {cls.description}
                </p>

                <div className="mt-auto pt-4 border-t border-cream-dark" data-id="element-125">
                  <p className="text-xs text-stone uppercase tracking-wider mb-4" data-id="element-126">
                    {cls.details}
                  </p>
                  <div className="flex items-center text-xs uppercase tracking-[0.2em] text-ink font-semibold group-hover:text-copper transition-colors" data-id="element-127">
                    Secure Your Spot{' '}
                    <span className="ml-2 transition-transform group-hover:translate-x-1" data-id="element-128">
                      &rarr;
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-16 text-center flex flex-col items-center" data-id="element-129">
          <a href="#all-classes" className="inline-block border-b border-ink pb-1 text-sm uppercase tracking-[0.2em] text-ink hover:text-copper hover:border-copper transition-colors mb-4" data-id="element-130">
            View All Upcoming Dates
          </a>
          <a href="#contact-form" className="text-sm text-stone hover:text-copper transition-colors" data-id="element-131">
            🎁 Gift vouchers available — give the gift of confidence
          </a>
        </div>
      </div>
    </section>;
}